import script from "./QuickRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickRoute.vue?vue&type=script&setup=true&lang=js"

import "./QuickRoute.vue?vue&type=style&index=0&id=2be41ff4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be41ff4"]])

export default __exports__